import React, { useState } from 'react';
import Img from 'img';
import Icon from 'icon';
import { navigate } from 'gatsby';
import Swiper from 'react-id-swiper';
import 'swiper/dist/css/swiper.css';
import s from './hero-slider.module.scss';

export default function HeroSlider({ slides, ...props }) {
  const [swiper, updateSwiper] = useState(null);

  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  const params = {
    preloadImages: false,
    autoplay: {
      delay: 5000,
    },
  };

  return (
    <section className={s.root}>
      <Swiper getSwiper={updateSwiper} {...params}>
        {slides.map(({ image, href }) => (
          <div className={s.wrapper}>
            <div className={s.overlay} onClick={() => navigate(href)} />
            <div className={s.imgWrapper}>
              <Img className={s.img} src={image} alt={image.title} />
            </div>
            <div className="container">
              <div className={s.prev} onClick={goPrev}>
                <Icon icon="slider-prev" />
              </div>
              <div className={s.next} onClick={goNext}>
                <Icon icon="slider-next" />
              </div>
            </div>
          </div>
        ))}
      </Swiper>
    </section>
  );
}
